// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__OBRZq","productName":"Table_productName__2uDxF"};